import React, { Component } from "react";
import PageHelmet from "../../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import FooterTwo from "../../component/footer/FooterTwo";

interface Props {}

class Go4contact extends Component<Props>{
    render(): React.ReactNode{
        return(
            <React.Fragment>
                
                <PageHelmet pageTitle='Project Details' />

                <Header headertransparent="header--transparent" colorblack="color--white" logoname="logo.png" />

                <div className="rn-page-title-area pt--120 pb--190" style={{ backgroundImage: `url("/assets/images/banner-bg.jpg")` }}  >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-color ">Go4Contact</h2>
                                    <p>Web App</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                    
                                        <div className="row sercice-details-content pb--80">
                                            <div className="col-lg-12 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4contact/5.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div className="row sercice-details-content pb--80">
                                            <div className="col-lg-12 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h4 className="title">Rich Messaging Web App &ndash; Advanced Communication Platform</h4>
                                                    <p>Collaborating as part of a three-member team, I co-developed a rich messaging web application leveraging Node.js, Laravel, and Vue.js. Designed to address multi-channel communication needs, this platform combines innovative features with real-time capabilities for seamless user interaction.</p>
                                                    <p><strong>API Integration:</strong> Incorporated WhatsApp and Telegram APIs to enable smooth and intuitive messaging that mimics the original platforms.</p>
                                                    <p><strong>Custom Features:</strong> Broadcast messages with randomized intervals, enhancing safety and reducing detection risks. Multi-account support to facilitate the management of multiple profiles within a single platform. API behavior aligned with the native experiences of WhatsApp and Telegram for user familiarity.</p>
                                                    <p><strong>Real-Time Functionality:</strong> Utilized Laravel WebSocket for instant notifications and updates, creating a dynamic user experience.</p>
                                                    <p><strong>Efficient SMS Routing:</strong> Engineered an SMPP randomization system with a weighting algorithm to optimize message distribution and reliability.</p>
                                                    <p>This collaborative project reflects our expertise in full-stack development showcasing a deep understanding of creating scalable and secure communication platforms.</p>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <h2 className="text-center mb--50">Project Screenshots</h2>

                                        <div className="row sercice-details-content align-items-center">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4contact/2.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4contact/3.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4contact/4.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row sercice-details-content align-items-center mt--30">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4contact/5.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>
                                    

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                
                <FooterTwo />
            </React.Fragment>
        )
    }
}
export default Go4contact;
